import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Divider,
  Grid,
  Paper,
  Snackbar,
  Typography,
  CircularProgress,
  Breadcrumbs,
  HomeIcon,
  WhatshotIcon,
  FormHelperText,
  FormControl,
  Select,
  InputLabel,
  MuiAlert,
  MenuItem,
  NavLink,
  makeStyles,
  commonService,
} from "../../../common";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "3rem",
    padding: theme.spacing(3),
  },
  formControl: {
    margin: theme.spacing(1),
    // minWidth: 120,
  },
  formLabel: {
    color: "#2B335E",
    fontSize: "1.25rem",
    letterSpacing: "0.014375rem",
    margin: "0 0 0 0.75rem",
  },
  error: {
    color: "#FF0F0F",
  },
  radioBtnStyle: {
    border: "1px solid #BEBDBD",
    width: "100%",
    borderRadius: "5px",
    margin: "0 0 0 -1px",
  },
  selectEmpty: {
    // marginTop: theme.spacing(2),
  },
  link: {
    display: "flex",
  },
  icon: {
    marginRight: theme.spacing(0.5),
    width: 20,
    height: 20,
  },
  btnContainer: {
    paddingTop: "5rem",
  },
  divider: {
    marginTop: "3rem",
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

let totalInputLengthArr = [false, false, false];
export default function CreateNewAccount() {
  const classes = useStyles();
  const [userType, setUserType] = useState("");
  const [level, setLevel] = useState("");
  const [levelTypeList, setLevelTypeList] = useState([]);
  const [errorMsgBody, setErrorMsgBody] = useState("");
  const [successMsgBody, setSuccessMsgBody] = useState("");
  const [error, setError] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [errors, setErrors] = useState({});
  const [remainingInputfield, setRemainingInputfield] = React.useState(3);
  const [totalInputfield, setTotalInputfield] = React.useState(3);
  const [accountInfo, setAccountInfo] = useState("");
  const [accountsList, setAccountsList] = useState([]);
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = async () => {
    const levelWiseAccountInfo = {
      level_id: level,
      type: userType,
      account_no: accountInfo,
    };

    setLoading(true);
    if (handleError()) {
      const res = await commonService.createLevelWiseAccount(
        levelWiseAccountInfo
      );
      res?.code === 200 && setOpen(true);
      setLoading(false);
      setSuccessMsgBody("Account SetUp Successfully Added.");
      setTimeout(() => {
        clearFormInput();
      }, 2000);
      res?.code !== 200 && setError(true);
      setLoading(false);
      if (res && res.messages) {
        setErrorMsgBody(res.messages);
      } else {
        setErrorMsgBody("something is wrong");
      }
    } else {
      timer.current = window.setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  const handleError = () => {
    let formIsValid = true;
    let errors = {};
    if (userType === "") {
      formIsValid = false;
      errors["userType"] = "Type can't left empty.";
    }
    if (level === "") {
      formIsValid = false;
      errors["level"] = "Level can't left empty.";
    }
    if (accountInfo === "") {
      formIsValid = false;
      errors["accountInfo"] = "Account Info can't left empty.";
    }
    setErrors(errors);
    return formIsValid;
  };

  const clearFormInput = () => {
    setRemainingInputfield(3);
    setUserType("");
    setLevel("");
    setAccountInfo("");
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleErrorClose = (event) => {
    setError(false);
  };

  const timer = React.useRef();

  const getLevels = async () => {
    const levelType = await commonService.getLevel("");
    setLevelTypeList(levelType.data?.levels);
  };
  const getAccountss = async () => {
    const accounts = await commonService.getAccounts();
    setAccountsList(accounts.data?.accounts);
  };

  useEffect(() => {
    getLevels();
    getAccountss();
    return () => {
      clearTimeout(timer.current);
    };
  }, []);

  return (
    <Grid xl={12} container className={classes.root}>
      {/* {console.log('totalInputLengthArr', totalInputLengthArr)} */}
      <Snackbar
        open={open}
        autoHideDuration={1500}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleClose} severity="success">
          {successMsgBody}
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={error}
        autoHideDuration={1500}
        onClose={handleErrorClose}
      >
        <Alert onClose={handleErrorClose} severity="error">
          {errorMsgBody}
        </Alert>
      </Snackbar>
      <Grid item xl={12}>
        <Breadcrumbs style={{ marginTop: "10px" }} aria-label="breadcrumb">
          <NavLink color="inherit" to="/dashboard" className={classes.link}>
            <HomeIcon className={classes.icon} />
            Home
          </NavLink>
          <NavLink
            color="inherit"
            to="/account-setup/view-all"
            className={classes.link}
          >
            <WhatshotIcon className={classes.icon} />
            Account SetUp
          </NavLink>
          <Typography color="textPrimary" className={classes.link}>
            Create
          </Typography>
        </Breadcrumbs>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            style={{
              textAlign: "left",
              margin: "15px 0",
              color: "#2B335E",
              fontSize: "25px",
            }}
          >
            Create Account SetUp
          </Typography>

          <NavLink
            to="/account-setup/view-all"
            variant="contained"
            style={{ height: "30px", textDecoration: "none" }}
          >
            <Typography
              style={{
                color: "#2B335E",
                fontSize: "18px",
              }}
            >
              View Account SetUp List
            </Typography>
          </NavLink>
        </div>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Paper style={{ padding: "20px", textAlign: "left" }}>
          <Grid container spacing={2}>
            <Grid item xs="6">
              <Grid container xs={12} spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <InputLabel
                    id="demo-simple-select-filled-label"
                    className={classes.formLabel}
                  >
                    Level
                  </InputLabel>
                  <FormControl
                    fullWidth
                    className={classes.formControl}
                    size="small"
                    id="sender"
                  >
                    <Select
                      variant="outlined"
                      labelId="demo-simple-select-filled-label"
                      id="demo-simple-select-filled"
                      value={level}
                      name="level"
                      onChange={(e) => {
                        setLevel(e.target.value);
                        setErrors({});
                        if (e.target.value !== "") {
                          if (totalInputLengthArr[0] == false) {
                            totalInputLengthArr[0] = true;
                            setRemainingInputfield(remainingInputfield - 1);
                          }
                        } else {
                          setRemainingInputfield(remainingInputfield + 1);
                          totalInputLengthArr[0] = false;
                        }
                      }}
                      label="Level"
                      notched={false}
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {levelTypeList.map((user) => (
                        <MenuItem value={user.id}>{user.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormHelperText className={classes.error}>
                    {errors["level"]}
                  </FormHelperText>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs="6">
              <Grid container xs={12} spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} spacing={2}>
                  <InputLabel
                    id="demo-simple-select-filled-label"
                    className={classes.formLabel}
                  >
                    Account Type
                  </InputLabel>
                  <FormControl
                    fullWidth
                    className={classes.formControl}
                    size="small"
                    id="sender"
                  >
                    <Select
                      variant="outlined"
                      labelId="demo-simple-select-filled-label"
                      id="demo-simple-select-filled"
                      placeholder="Select Type"
                      value={userType}
                      name="userType"
                      onChange={async (e) => {
                        setUserType(e.target.value);

                        if (e.target.value === "charge") {
                          const accounts =
                            await commonService.getSelectedAccounts(
                              e.target.value
                            );
                          setAccountsList(accounts.data?.accounts);
                        } else if (e.target.value === "cashback") {
                          const accounts =
                            await commonService.getSelectedAccounts(
                              e.target.value
                            );
                          setAccountsList(accounts.data?.accounts);
                        } else if (e.target.value === "reward") {
                          const accounts =
                            await commonService.getSelectedAccounts(
                              e.target.value
                            );
                          setAccountsList(accounts.data?.accounts);
                        } else {
                          const accounts = await commonService.getAccounts();
                          setAccountsList(accounts.data?.accounts);
                        }

                        setErrors({});
                        if (e.target.value !== "") {
                          if (totalInputLengthArr[1] == false) {
                            totalInputLengthArr[1] = true;
                            setRemainingInputfield(remainingInputfield - 1);
                          }
                        } else {
                          setRemainingInputfield(remainingInputfield + 1);
                          totalInputLengthArr[1] = false;
                        }
                      }}
                      label="Type"
                      notched={false}
                    >
                      <MenuItem value="">
                        <span>None</span>
                      </MenuItem>
                      <MenuItem value="charge">
                        <span>Charge</span>
                      </MenuItem>
                      <MenuItem value="cashback">
                        <span>Cashback</span>
                      </MenuItem>
                      <MenuItem value="reward">
                        <span>Reward</span>
                      </MenuItem>
                    </Select>
                    <FormHelperText className={classes.error}>
                      {errors["userType"]}
                    </FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs="6">
              <Grid container xs={12} spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} spacing={2}>
                  <InputLabel
                    id="demo-simple-select-filled-label"
                    className={classes.formLabel}
                  >
                    Account Info
                  </InputLabel>
                  <FormControl
                    fullWidth
                    className={classes.formControl}
                    size="small"
                    id="sender"
                  >
                    <Select
                      variant="outlined"
                      labelId="demo-simple-select-filled-label"
                      id="demo-simple-select-filled"
                      value={accountInfo}
                      onChange={(e) => {
                        setAccountInfo(e.target.value);
                        setErrors({});
                        if (e.target.value !== "") {
                          if (totalInputLengthArr[2] == false) {
                            totalInputLengthArr[2] = true;
                            setRemainingInputfield(remainingInputfield - 1);
                          }
                        } else {
                          setRemainingInputfield(remainingInputfield + 1);
                          totalInputLengthArr[2] = false;
                        }
                      }}
                      label="Account Info"
                      name="accountInfo"
                      notched={false}
                    >
                      <MenuItem value="">
                        <span>None</span>
                      </MenuItem>
                      {accountsList.map((user) => (
                        <MenuItem key={user.account_no} value={user.account_no}>
                          {user.name}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText className={classes.error}>
                      {errors["accountInfo"]}
                    </FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              xl={12}
              md={12}
              sm={12}
              xs={12}
              lg={12}
              justify="space-between"
              alignItems="center"
              className={classes.divider}
            >
              {" "}
              <Divider style={{ margin: "20px 0", color: "#00000029" }} />
            </Grid>

            <Grid
              item
              container
              xl={12}
              justify="space-between"
              alignItems="center"
              className={classes.btnContainer}
            >
              <Grid item xl={6} md={6} sm={6} xs={6} lg={6}>
                {/* <Box ml={1}>
                  {remainingInputfield}/{totalInputfield} input remaining
                </Box> */}
              </Grid>
              <Grid
                item
                container
                xl={6}
                md={6}
                sm={6}
                xs={6}
                lg={6}
                justify="flex-end"
                alignItems="center"
              >
                <Box mr={5}>
                  <Button
                    variant="contained"
                    className={classes.cancelBtn}
                    onClick={clearFormInput}
                  >
                    CANCEL
                  </Button>
                </Box>
                <Box mr={1}>
                  <Button
                    variant="contained"
                    color="secondary"
                    className="btn btn-primary btn-block"
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    {loading && <CircularProgress size={17} />}
                    Create & add another
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
}
